export function TrialExpiredOverlay({ onPay, onOpenPromo }) {
  return (
    <div className="trial-expired-overlay">
      <div className="trial-expired-content">
        <div className="modal-icon">⏰</div>
        <h2>Your trial has ended</h2>
        <p>Continue your journey with Aura for just <strong>$4.99</strong></p>
        <button className="init-btn" onClick={onPay} data-testid="trial-expired-pay-btn">
          Continue for $4.99
        </button>
        {onOpenPromo && (
          <button
            type="button"
            className="promo-link-inline"
            onClick={onOpenPromo}
            data-testid="trial-expired-promo-link"
          >
            Have a promo code?
          </button>
        )}
      </div>
    </div>
  );
}
